export default [
  [`Размеры`, `2XS`, `XS `, `S`, `M`, `L`, `XL`],
  [`Российский размер`, `40`, `42`, `44`, `46`, `48`, `50`],
  [`Рост`, `164`, `164`, `170`, `170`, `170`, `170`],
  [`Обхват груди(a)`, `80`, `84`, `88`, `92`, `96`, `100`],
  [`Обхват бедер (b)`, `86`, `90`, `94`, `98`, `102`, `106`],
  [`Длины спины по центру (c)`, `88`, `88`, `90`, `93`, `96`, `99`],
  [`Ширина на уровне проймы (d)`, `45`, `47`, `49`, `51`, `54`, `56`],
  [`Ширина талии (e)`, `42`, `44`, `46`, `48`, `51`, `53`],
  [`Ширина бёдер (f)`, `46`, `48`, `50`, `53`, `55`, `58`],
  [`Ширина низа (g)`, `46`, `48`, `50`, `52`, `55`, `57`]
];
